export const ENTRY_FORM_CODE = {
  HEALTH_BASIC_ENTRY_FORM: "health-basic-entry-form",
  MOTOR_BASIC_ENTRY_FORM: "motor-basic-entry-form",
  HEALTH_REVISED_CONTENT_ENTRY_FORM: "health-revised-content-entry-form",
};

export const ENTRY_FORM_INPUT_CODE = {
  EFFECTIVE_DATE: "effectiveDate",
  INSURED_DATE_OF_BIRTH: "insuredDateOfBirth",
  INSURED_GENDER: "insuredGender",
  INSURED_MARITAL_STATUS: "maritalStatus",
};
